export default __webpack_public_path__ + "static/media/close-menu.9945c68a.svg";